import { QUERY_KEY_LIST_BOOKING_CARS } from '~/features/BookingCars/ListBookingCars'
import { useRefreshList } from '~/shared/ui/ScrollableList'

export const useRefreshPage = () => {
  const { refreshList } = useRefreshList(QUERY_KEY_LIST_BOOKING_CARS)

  const refreshPage = async () => {
    await refreshList()
  }

  return { refreshPage }
}
